import { render, staticRenderFns } from "./multiRowBox.vue?vue&type=template&id=39b234fa&"
import script from "./multiRowBox.vue?vue&type=script&lang=js&"
export * from "./multiRowBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports